import request from "../utils/businessservice";
import Configs from "@/configs";
///获取对象
export function getLogin(data) {
  return request({
    url: Configs.authBaseUrl + "/auth/estate_login", ///测试Api地址
    method: "POST",
    data: data,
  });
}
export function getOut(data) {
  return request({
    url: Configs.authBaseUrl + "/auth/logout", ///退出登录
    method: "DELETE",
  });
}

export function getAllEstatehandle(data) {
  return request({
    // url: "http://8.138.209.52:8083/general-api/system/estate/allEstatehandle", ///地图
    url: "/supervision/complant/allEstatehandle", ///地图
    method: "Get",
  });
}


export function getEstateRanking(data) {
  return request({
    url: "/supervision/estateRanking", ///物业公司排名
    method: "Get",
  });
}

export function getAllEstateComplaint(data) {
  return request({
    // url: "http://8.138.209.52:8083/general-api/system/estate/allEstateComplaint", ///业主投诉
    url: "/supervision/complant/estateComplaintSuggestionNum", ///业主投诉
    method: "Get",
  });
}

export function getAllEstateTodo(data) {
  return request({
    // url: "http://8.138.209.52:8083/general-api/system/estate/allEstateTodo",
    url: "/supervision/complant/estateReportWarrantyNum", ///业主投诉
    method: "Get",
  });
}

export function getRankingCircularDiagram(data) {
  return request({
    url: "/supervision/rankingCircularDiagram", ///环图
    method: "Get",
  });
}


export function getEstateAbility(data) {
  return request({
    url: "/supervision/estateAbility", ///雷达图
    method: "Get",
  });
}

export function getEstateHandleData(data) {
  return request({
    url: "/supervision/estateHandleData", ///首页头部数据
    method: "Get",
  });
}


